export default __webpack_public_path__ + "static/logo-invert-6a5bad806552700bd091ce8718a21d87.png";